var MarketLocaleInterceptor = (function () {
    function MarketLocaleInterceptor($q, websiteConfiguration, localeService) {
        var _this = this;
        this.$q = $q;
        this.websiteConfiguration = websiteConfiguration;
        this.localeService = localeService;
        this.request = function (config) {
            if (config.url.indexOf('marketLocale=') > -1) {
                return config || _this.$q.when(config);
            }
            if (config.url.indexOf('api/') > -1 || config.url.indexOf('v1') > -1) {
                var marketLocale = _this.websiteConfiguration.marketLocale;
                config.url += (config.url.indexOf('?') > -1 ? '&' : '?') + ("marketLocale=" + marketLocale);
            }
            var isScApiRequest = config.method === 'GET' && (config.url.includes('ng-translation') || config.url.includes('ng-settings'));
            if (isScApiRequest && !config.url.startsWith(_this.localeService.localePrefix())) {
                config.url = _this.localeService.localePrefix() + "/" + config.url;
            }
            return config || _this.$q.when(config);
        };
    }
    MarketLocaleInterceptor.Factory = function ($q, websiteConfiguration, localeService) {
        return new MarketLocaleInterceptor($q, websiteConfiguration, localeService);
    };
    return MarketLocaleInterceptor;
}());
export { MarketLocaleInterceptor };
